import React from 'react';
import './BookStock.css';

const ErrorLabel = (props) => {
  return (
    <div className="error-fill-all-labels">{props.errorMessge}</div>
  );
}

export default ErrorLabel;